// extracted by mini-css-extract-plugin
module.exports = {"title":"xVfcq"};